import api from "../../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== "" && data[key] !== undefined) {
        params += `${key}=${data[key]}&`;
      }
    });
    return api.get(`/api/v1/j-subcategory?${params}`);
  },
  getAllList() {
    return api.post(`/api/v1/j-subcategory/list`);
  },
  getById(id) {
    return api.get(`/api/v1/j-subcategory/${id}`);
  },
  update(id, data) {
    return api.post(`/api/v1/j-subcategory/${id}`, data);
  },
  create(data) {
    return api.post(`/api/v1/j-subcategory`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/j-subcategory/${id}`);
  },
};
